import { render, staticRenderFns } from "./EntoDateRangeELISAResult.vue?vue&type=template&id=5222ab62&"
import script from "./EntoDateRangeELISAResult.vue?vue&type=script&lang=js&"
export * from "./EntoDateRangeELISAResult.vue?vue&type=script&lang=js&"
import style0 from "./EntoDateRangeELISAResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports